/**
 * @file   remote-data-pattern.js - Contains the class definition with two arguments: pattern 
 * and number of slices.
 * 
 * @see    {@link https://kingsds.atlassian.net/browse/DCP-2313|Jira Issue}
 * @author Nazila Akhavan <nazila@kingsds.network>
 * @date   Sep. 2021
 */

const { DCPError } = require('dcp/common/dcp-error')
const { DcpURL } = require('dcp/common/dcp-url');

const debugging = require('dcp/debugging').scope('dcp-client');
const debug = (...args) => {
  if (debugging('compute:remote-data-set')) {
    args.unshift('dcp-client:compute:remote-data-set');
    console.debug(...args);
  }
};

/**
 * Instances of this class store URIs representing job input data sets. The
 * primary purpose of this class, at this time, is to prevent repeating uri's 
 * that have the similar pattern(example: 'http://site.com/1.json','http://site.com/2.json') and allow us to pass only the pattern and the
 * number of slices. Later in the requestTask, all slices based on the pattern will be fetched.
 *
 * 
 * @example
 * const { RemoteDataPattern } = require('dcp/compute');
 * const pattern = 'http://site.com/{slice}.json';
 * let b = new RemoteDataPattern(pattern, 2);
 * const job = compute.for(b, function(el) { console.log(el)});
 * await job.exec();
 */
/**
 * 
 * @param {string | URL} pattern            pattern of the uri's and SHOULD includes '{slice}'
 * @param {number} sliceCount         total number of slices
 */
module.exports.RemoteDataPattern = function (pattern, sliceCount)
{
  let isPattern;

  if (!new.target)
    return new module.exports.RemoteDataPattern(pattern, sliceCount);

  if (typeof pattern === 'string')
    isPattern = pattern.match(/\{slice\}/);

  if (DcpURL.isURL(pattern)) {
    isPattern = pattern.href.match(/%7Bslice%7D/);
    if(isPattern)
      pattern = pattern.href.replace('%7Bslice%7D', '{slice}');
  }
  if(!isPattern || !sliceCount || typeof Number(sliceCount) !== 'number') {
    throw new DCPError(`invalid pattern/sliceCount:Note that pattern should includes "{slice}"\n pattern:${pattern}, sliceCount:${sliceCount}`);
  }
  this.length = 2;
  this['pattern'] = pattern;
  this['sliceCount'] = sliceCount;
}

module.exports.RemoteDataPattern.isRemoteDataPattern = function (r)
{
  if (r instanceof module.exports.RemoteDataPattern)
    return true;

  return false;
}

module.exports.RemoteDataPattern.isProtoRemoteDataPatternLike = function (r) {
  if (typeof r === 'object' && typeof r.sliceCount === 'number')
  {// pattern should include '{slice}'
    if (typeof r.pattern === 'string' && r.pattern.match(/\{slice\}/))
      return true;
    if (DcpURL.isURL(r.pattern) && r.pattern.href.match(/%7Bslice%7D/))
      return true;
  }

  return false;
}

module.exports.RemoteDataPattern.prototype = new Array(); 